export default __webpack_public_path__ + "static/media/14t.e6bb2f64.jpg";